<script setup>
import ShipTable from '@/components/ship/ShipTable.vue'
import BulkDeleteDialog from '@/components/dialog/BulkDeleteDialog.vue'
import ImportShipDialog from '@/components/import-ship/ImportShipDialog.vue'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useShipStore } from '@/stores/ship'
import ExportExcelDialog from '@/components/calculation/ExportExcelDialog.vue'
import { useCalculationStore } from '@/stores/calculation'
import ShipTableControl from '@/components/ship/ShipTableControl.vue'

const shipStore = useShipStore()
const calculationStore = useCalculationStore()

const { downloadLoading } = storeToRefs(calculationStore)

const {
  deleteLoading: shipDeleteLoading,
  deleteDialog: shipDeleteDialog,
  selectedItems: selectedShips
} = storeToRefs(shipStore)

const addShipDialog = ref(false)
const exportDialog = ref(false)

const deleteShips = async () => {
  await shipStore.bulkDelete(selectedShips.value)
  shipStore.toggleDeleteDialog()
  shipStore.emptySelectedItems()
}

const exportExcel = async () => {
  await calculationStore.export()
  exportDialog.value = false
}

const setDialog = (value) => {
  addShipDialog.value = value
}
const setExportDialog = (value) => {
  exportDialog.value = value
}
</script>

<template>
  <div>
    <ShipTableControl @set-add-dialog="setDialog" @set-export-dialog="setExportDialog" />
    <ShipTable />

    <ImportShipDialog :dialog="addShipDialog" @setDialog="setDialog"></ImportShipDialog>

    <BulkDeleteDialog
      :bulk-delete="true"
      :items-to-delete="selectedShips"
      :delete-dialog="shipDeleteDialog"
      :delete-loading="shipDeleteLoading"
      @delete="deleteShips()"
      @toggle-dialog="shipStore.toggleDeleteDialog()"
    ></BulkDeleteDialog>

    <ExportExcelDialog
      v-model="exportDialog"
      :loading="downloadLoading"
      @export-excel="exportExcel()"
    ></ExportExcelDialog>
  </div>
</template>
